import i18n from '@/i18n';
import { getIpeWorkspaceMode } from '@/utils/api';
import { normalizeWorkspaceMode } from './accountCenterUtils';

/**
 * 用户端个人/团队图片空间容量预警（非 Admin OSS 预警）。
 * 剩余 < 5GB 或配额已满时展示，「提升容量」跳转服务增强 → 图片空间扩容。
 */
export function isUserStorageCapacityWarning(quota) {
  if (!quota) return false;
  return Boolean(quota.storageLowWarning || quota.storageAtLimit);
}

/**
 * 容量告警正文（始终带个人/团队前缀，与通知中心一致）。
 * @param {object} quota
 * @param {'personal'|'team'|string} [workspaceMode]
 */
export function resolveUserStorageCapacityWarningMessage(quota, workspaceMode) {
  const scope = normalizeWorkspaceMode(workspaceMode ?? getIpeWorkspaceMode());
  const label = i18n.t(scope === 'team' ? 'teamShort' : 'personalShort');
  if (quota?.storageAtLimit) {
    return i18n.t('storageFullMessage', { scope: label });
  }
  const backend = quota?.storageLowWarningMessage;
  if (backend && (String(backend).includes('个人') || String(backend).includes('团队'))) {
    return String(backend);
  }
  return i18n.t('storageLowMessage', { scope: label });
}

/** 打开服务增强 → 图片空间扩容（跟随当前 personal/team 工作区） */
export function openStoragePurchaseModal(packScope) {
  if (typeof window === 'undefined') return;
  const scope = packScope === 'team' || packScope === 'personal'
    ? packScope
    : getIpeWorkspaceMode();
  window.dispatchEvent(new CustomEvent('ipe:open-storage-purchase', {
    detail: { packScope: scope },
  }));
}
